export default __webpack_public_path__ + "i18n/translation-th.df77556b.json";